import React, { useEffect, useState } from "react";
import CdrService from "../../services/v2/cdr-service";
import { FaRegCircleUser } from "react-icons/fa6";

const formatDateTime = (date) => {
  const timestamp = new Date(date);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timestamp.toLocaleString(undefined, {
    timeZone: userTimeZone,
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
};

const CdrEvents = ({ id }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data } = await CdrService.cdrEvents(id);
        if (data.status === "Success") {
          setEvents(data.data);
        } else {
          throw new Error("Failed to fetch events");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchEvents();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-10">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-10 text-center text-red-500">
        An error occurred: {error}
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="py-10 text-center text-gray-500">
        No events found for this call.
      </div>
    );
  }

  return (
    <div className="p-4 w-full">
      <div className="max-h-[400px] overflow-y-auto custom-scroll">
        {events.map((event, index) => (
          <div key={index} className="flex">
            <div className="flex flex-col items-center mr-4">
              <div>
                <div className="flex items-center justify-center w-10 h-10 border rounded-full bg-purple-200">
                  <svg
                    className="w-4 text-purple-800"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                  >
                    <line
                      fill="none"
                      strokeMiterlimit="10"
                      x1="12"
                      y1="2"
                      x2="12"
                      y2="22"
                    />
                    <polyline
                      fill="none"
                      strokeMiterlimit="10"
                      points="19,15 12,22 5,15"
                    />
                  </svg>
                </div>
              </div>
              {index !== events.length - 1 && (
                <div className="w-px h-full bg-gray-300" />
              )}
            </div>
            <div className="pt-1 pb-8">
              <p className="text-gray-700 text-sm">
                {formatDateTime(event.timestamp)}
              </p>
              <p className="mb-2 text-lg font-bold">{event.event}</p>
              {event.additionalInfo && (
                <p className="text-md text-gray-500 flex gap-2">
                  <FaRegCircleUser />
                  {event.additionalInfo}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CdrEvents;
